import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const BASE = `${config.BASE_URL}/finance-payments`;


async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

function assertOk(res, data, fallbackMessage) {
  if (!res.ok) throw new Error(data.message || fallbackMessage);
}

export const fetchPaymentModes = async (activeOnly = false) => {
  const q = activeOnly ? "?active_only=true" : "";
  const res = await authFetch(`${BASE}/payment-modes${q}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch payment modes");
  return data;
};

export const getPaymentModeById = async (id) => {
  const res = await authFetch(
    `${BASE}/payment-modes/${encodeURIComponent(String(id))}`,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch payment mode");
  return data;
};

export const createPaymentMode = async (data, csrfToken) => {
  const res = await authFetch(`${BASE}/payment-modes`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    body: JSON.stringify(data),
  });
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to create payment mode");
  return payload;
};

export const updatePaymentMode = async (id, data, csrfToken) => {
  const res = await authFetch(
    `${BASE}/payment-modes/${encodeURIComponent(String(id))}`,
    {
      method: "PUT",
      credentials: "include",
      headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
      body: JSON.stringify(data),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to update payment mode");
  return payload;
};

export const deletePaymentMode = async (id, csrfToken) => {
  const res = await authFetch(
    `${BASE}/payment-modes/${encodeURIComponent(String(id))}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to remove payment mode");
  return payload;
};

export const fetchPaymentPurposes = async (activeOnly = false) => {
  const q = activeOnly ? "?active_only=true" : "";
  const res = await authFetch(`${BASE}/payment-purposes${q}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch payment purposes");
  return data;
};

export const getPaymentPurposeById = async (id) => {
  const res = await authFetch(
    `${BASE}/payment-purposes/${encodeURIComponent(String(id))}`,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch payment purpose");
  return data;
};

export const createPaymentPurpose = async (data, csrfToken) => {
  const res = await authFetch(`${BASE}/payment-purposes`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    body: JSON.stringify(data),
  });
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to create payment purpose");
  return payload;
};

export const updatePaymentPurpose = async (id, data, csrfToken) => {
  const res = await authFetch(
    `${BASE}/payment-purposes/${encodeURIComponent(String(id))}`,
    {
      method: "PUT",
      credentials: "include",
      headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
      body: JSON.stringify(data),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to update payment purpose");
  return payload;
};

export const deletePaymentPurpose = async (id, csrfToken) => {
  const res = await authFetch(
    `${BASE}/payment-purposes/${encodeURIComponent(String(id))}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to remove payment purpose");
  return payload;
};

export const fetchPaymentSubTypes = async (activeOnly = false) => {
  const q = activeOnly ? "?active_only=true" : "";
  const res = await authFetch(`${BASE}/payment-sub-types${q}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch payment sub-types");
  return data;
};

export const getPaymentSubTypeById = async (id) => {
  const res = await authFetch(
    `${BASE}/payment-sub-types/${encodeURIComponent(String(id))}`,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch payment sub-type");
  return data;
};

export const createPaymentSubType = async (data, csrfToken) => {
  const res = await authFetch(`${BASE}/payment-sub-types`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    body: JSON.stringify(data),
  });
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to create payment sub-type");
  return payload;
};

export const updatePaymentSubType = async (id, data, csrfToken) => {
  const res = await authFetch(
    `${BASE}/payment-sub-types/${encodeURIComponent(String(id))}`,
    {
      method: "PUT",
      credentials: "include",
      headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
      body: JSON.stringify(data),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to update payment sub-type");
  return payload;
};

export const deletePaymentSubType = async (id, csrfToken) => {
  const res = await authFetch(
    `${BASE}/payment-sub-types/${encodeURIComponent(String(id))}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to remove payment sub-type");
  return payload;
};

//** Master Collected By Types */
const COLLECTED_BY_TYPES_URL = `${BASE}/collected-by-types`;

export const fetchCollectedByTypes = async (activeOnly = false) => {
  const res = await authFetch(
    `${COLLECTED_BY_TYPES_URL}?active_only=${activeOnly}`,
    {
      method: "GET",
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch collection sources");
  return data;
};

export const fetchCollectedByTypeById = async (id) => {
  const res = await authFetch(`${COLLECTED_BY_TYPES_URL}/${id}`, {
    method: "GET",
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch collection source");
  return data;
};

export const createCollectedByType = async (typeData) => {
  const res = await authFetch(COLLECTED_BY_TYPES_URL, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(),
    body: JSON.stringify(typeData),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to add collection source");
  return data;
};

export const updateCollectedByType = async (id, typeData) => {
  const res = await authFetch(`${COLLECTED_BY_TYPES_URL}/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(),
    body: JSON.stringify(typeData),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to update collection source");
  return data;
};

export const deleteCollectedByType = async (id) => {
  const res = await authFetch(`${COLLECTED_BY_TYPES_URL}/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to delete collection source");
  return data;
};
